import {
  CustomFieldType,
  IFieldConfig,
} from "@shared/lib/types/briefInfluencerV2";
import { Button, Popconfirm } from "@shared/ui";
import { Trash2, X } from "lucide-react";
import styles from "../styles.module.scss";

interface BriefCustomFieldInlineViewProps {
  field: IFieldConfig;
  onClose: () => void;
  onDelete?: (field: IFieldConfig) => void;
  isDeleting?: boolean;
}

export function BriefCustomFieldInlineView({
  field,
  onClose,
  onDelete,
  isDeleting = false,
}: BriefCustomFieldInlineViewProps) {
  return (
    <div className={styles.inlineFieldPanel}>
      <div className={styles.inlineFieldPanelHeader}>
        <p className={styles.inlineFieldPanelTitle}>Column details</p>
        <button
          type="button"
          className={styles.inlineFieldPanelClose}
          onClick={onClose}
          aria-label="Close"
        >
          <X size={14} />
        </button>
      </div>

      <div className={styles.inlineFieldPanelContent}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Field Name</label>
          <div className={styles.fieldViewValue}>
            {field.displayName || field.key}
          </div>
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Data Type</label>
          <div className={styles.fieldViewValue}>
            {field.type
              ? field.type.charAt(0).toUpperCase() + field.type.slice(1)
              : "Text"}
          </div>
        </div>

        {field.type === CustomFieldType.DROPDOWN && field.dropdownOptions ? (
          <div className={styles.formGroup}>
            <label className={styles.label}>Options</label>
            <div className={styles.dropdownOptionsView}>
              {field.dropdownOptions.map((option, index) => (
                <div key={index} className={styles.optionViewItem}>
                  {option}
                </div>
              ))}
            </div>
          </div>
        ) : null}

        {field.defaultValue !== undefined &&
        field.defaultValue !== null &&
        field.defaultValue !== "" ? (
          <div className={styles.formGroup}>
            <label className={styles.label}>Default Value</label>
            <div className={styles.fieldViewValue}>
              {Array.isArray(field.defaultValue)
                ? field.defaultValue.join(", ")
                : String(field.defaultValue)}
            </div>
          </div>
        ) : null}

        {field.type === CustomFieldType.UPLOAD ? (
          <div className={styles.uploadInfo}>
            <p>
              Upload fields allow you to attach files or links to each creator.
              Multiple items are supported.
            </p>
          </div>
        ) : null}
      </div>

      {onDelete ? (
        <div className={styles.inlineFieldPanelActions}>
          <Popconfirm
            title="Delete Field"
            description="Are you sure you want to delete this field?"
            onConfirm={() => onDelete(field)}
            okText="Delete"
            cancelText="Cancel"
            okButtonProps={{ danger: true }}
          >
            <Button danger loading={isDeleting} size="small">
              <Trash2 size={14} style={{ marginRight: 8 }} />
              Delete Field
            </Button>
          </Popconfirm>
        </div>
      ) : null}
    </div>
  );
}
